import * as React from "react";
import Translate from "../../../common/functions/translate";
import Spinner from '../../../common/components/spinner/spinner';
import Snackbar from "../../../common/components/snackbar/snackbar";
import ConfirmDialog from '../../../common/components/confirmDialog/confirmDialog';
import { CategoryModel } from "../../../models/category/categoryModel";
import { CategoryFilterSettingsModel } from "../../../models/category/categoryFilterSettingsModel";
import CategoryService from '../../../services/categoriesService';
import CategoryAddEditDialog from './categoryAddEditDialog';
import { Button } from 'primereact/button';
import { TreeNodeModel } from '../../../models/treeNodeModel';
import { ContextMenu } from 'primereact/contextmenu';
import Paper from '@material-ui/core/Paper';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlusSquare, faMinusSquare } from '@fortawesome/free-regular-svg-icons';
//import CategoriesView from './categoriesView';
import { Tree } from 'primereact/tree';
import * as HelperFunctions from '../../../common/functions/helperFunctions';
import { CategoryType } from "../../../common/enums";

interface IProps {
}

interface IState {
  isLoading: boolean;
  error: any;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  validationMessage: string;
  isVisibleAddEditDialog: boolean;
  isVisibleConfirmDialog: boolean;
  categorySettings: CategoryFilterSettingsModel;
  categories: Array<CategoryModel>;
  currentCategory: CategoryModel;
  contextMenu: any;
  selectionKeys: any;
  selectedCategoryIds: Array<number>;
  treeCategories: Array<TreeNodeModel>;
  expandedKeys: any;
  expandToCategoryId: number;
  //isTypelessCategory: boolean;
}

const initFrom = 0;
const numberOfRows = 10;

class CategoriesContainer extends React.Component<IProps, IState> {
  snackbar: any;
  categoryService = new CategoryService();
  messages: any;
  cm: any;

  constructor(props: IProps) {
    super(props);

    const menu = [
      {
        label: Translate('SubCategory'),
        icon: 'pi pi-plus',
        command: () => { this.handleAddClick(this.state.selectedCategoryIds[0], 'child') }
      },
      {
        label: Translate('Edit'),
        icon: 'pi pi-pencil',
        command: () => { this.handleEditClick(this.state.selectedCategoryIds[0]) }
      },
      {
        label: Translate('Delete'),
        icon: 'pi pi-trash',
        command: () => { this.handleDeleteClick() }
      }
    ];

    this.state = {
      isLoading: false,
      error: null,
      validationMessage: '',
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      isVisibleAddEditDialog: false,
      isVisibleConfirmDialog: false,
      categorySettings: new CategoryFilterSettingsModel(),
      categories: new Array<CategoryModel>(0),
      currentCategory: new CategoryModel(),
      contextMenu: menu,
      selectionKeys: null,
      selectedCategoryIds: new Array<number>(0),
      treeCategories: new Array<TreeNodeModel>(0),
      expandedKeys: null,
      expandToCategoryId: 0
      //isTypelessCategory: false
    };
  }

  componentDidMount() {
    this.getAll();
  }

  getAll() {
    this.setState({
      isLoading: true
    });

    this.categoryService.getAllCategories().then(
      (data: any) => {
        this.setState({
          isLoading: false,
          categories: data,
        }, () => this.createTree());
        this.expandToCurrentCategory();
      })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  deconstructTree = (tree: Array<TreeNodeModel>, parentId: number, level: number) => {
    let arrayData = new Array<CategoryModel>(0);
    tree.forEach((item: TreeNodeModel, index: number) => {
      arrayData.push({
        id: item.data.id,
        parentId: parentId,
        categoryTypeId: item.data.categoryTypeId,
        name: item.label,
        levelNo: level,
        orderNo: index + 1,
        isActive: true
      })
      if (item.children && item.children.length > 0) {
        arrayData.push(...this.deconstructTree(item.children, item.data.id, level + 1));
      }
    });

    return arrayData;
  }

  createTree() {
    let subTree = this.createSubTree(null);
    this.setState({
      treeCategories: subTree
    });

    if (!this.state.expandToCategoryId) {
      this.expandMainParents({});
    }

    // if (this.state.categories.some(c => !c.categoryTypeId)) {
    //   setTimeout(this.showMissingCategoryTypeMssg, 2000);
    // }
  }

  showMissingCategoryTypeMssg = () => {
    this.snackbar.show({ severity: 'warning', summary: Translate("Categories without type. Please add type to all categories.") });
  }

  createSubTree(parentId) {
    let subTree = new Array<TreeNodeModel>(0);

    this.state.categories
      .filter(f => parentId ? f.parentId === parentId : f.parentId === null)
      .sort((a, b) => (a.orderNo > b.orderNo) ? 1 : (b.orderNo > a.orderNo ? -1 : 0))
      .map(f => {
        let node = new TreeNodeModel();
        node.key = f.id.toString();
        node.label = this.returnCategoryNodeLabel(f)
        node.data = { ...f };
        if (this.state.categories.some(a => a.parentId === f.id)) {
          node.children = this.createSubTree(f.id);
        };
        subTree.push(node);
        return 0;
      });

    return subTree;
  }

  returnCategoryNodeLabel = (category: CategoryModel) => {
    let label = category.name;

    if (category.categoryTypeId) {
      let typeName = HelperFunctions.getEnumLabel(category.categoryTypeId, CategoryType, true);
      label = label + " (" + typeName + ")";
    }

    return label;
  }

  expandMainParents = (expandedKeys) => {
    expandedKeys = expandedKeys ? expandedKeys : {};

    let mainCategories = this.state.categories.filter(p => p.parentId === null);
    if (mainCategories && mainCategories.length > 0) {
      mainCategories.forEach(c => {
        expandedKeys[c.id.toString()] = true;
      })
      this.setState({ expandedKeys: expandedKeys });
    }
  }

  expandToCurrentCategory = () => {
    let categoryId = 0;
    let currentCategory = this.state.categories.find(p => p.id === this.state.expandToCategoryId);
    if (currentCategory) {
      categoryId = currentCategory.parentId;
    }
    if (categoryId) {
      let expandedKeys = this.returnCategoriesToExpand(this.state.expandedKeys, categoryId);
      this.setState({
        expandedKeys: expandedKeys,
        expandToCategoryId: 0
      });
    }
  }

  returnCategoriesToExpand = (expandedKeys, categoryId) => {
    expandedKeys = expandedKeys ? expandedKeys : {};

    let currentCategory = this.state.categories.find(p => p.id === categoryId);
    if (currentCategory) {
      expandedKeys[currentCategory.id.toString()] = true;
      if (currentCategory.parentId != null || undefined) {
        this.returnCategoriesToExpand(expandedKeys, currentCategory.parentId);
      }
    }

    return expandedKeys;
  }

  handleCloseAddEditCategoryModal = () => {
    this.showEditDialog(false)
    this.setCurrentCategory(new CategoryModel());
    this.getAll();
  };

  handleSaveButton = (category: CategoryModel) => {
    this.setState({
      isLoading: true
    });

    if (!category.id) { // Add
      this.categoryService.addCategory(category)
        .then(
          (data) => {
            this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.setState({ isLoading: false });
            this.setState({ expandToCategoryId: data });
            this.handleCloseAddEditCategoryModal();
          },
          error => {
            this.snackbar.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false,
              validationMessage: error.message
            })
          }
        );
    } else { // Edit
      this.categoryService.editCategory(category)
        .then(
          (data) => {
            this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
            this.setState({ isLoading: false });
            this.setState({ expandToCategoryId: data });
            this.handleCloseAddEditCategoryModal();
          },
          error => {
            this.snackbar.show({ severity: 'error', summary: error.message });
            this.setState({
              isLoading: false,
              validationMessage: error.message
            });
          });
    }
  };

  handleAddClick = (parentId, type) => {
    let parent = this.state.categories.find(f => f.id === parentId);
    let parentLevelNo = parent ? parent.levelNo : 0;
    let newCategory = new CategoryModel();
    newCategory.parentId = parentId;
    newCategory.levelNo = (type === 'child' ? parentLevelNo + 1 : parentLevelNo);

    this.setCurrentCategory(newCategory);
    this.showEditDialog(true);
  };

  handleEditClick = id => {
    this.setState({
      isLoading: true
    });
    this.categoryService.getCategory(id)
      .then(
        (data: CategoryModel) => {
          this.setCurrentCategory(data);
          this.showEditDialog(true);
          this.setState({
            isLoading: false
          });
        })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  };

  handleDeleteClick = () => {
    this.setState({
      isVisibleConfirmDialog: true
    });
  };

  deleteCategoryTree(id: number) {
    this.setState({
      isVisibleConfirmDialog: false,
      isLoading: true
    });

    this.categoryService.deleteCategory(id)
      .then(
        data => {
          this.snackbar.show({ severity: 'success', summary: Translate('Deleted Successfully') });

          let deletedCategory = this.state.categories.find(f => f.id === id);
          if (deletedCategory && deletedCategory.parentId) {
            this.setState({ expandToCategoryId: deletedCategory.parentId });
          }

          this.getAll();
          this.setState({
            isLoading: false,
            selectionKeys: null,
            selectedCategoryIds: new Array<number>(0)
          });
        },
        error => {
          this.snackbar.show({ severity: 'error', summary: error.message });
          this.setState({
            error,
            isLoading: false
          });
        });
  }

  handleSelectionChange = (value) => {
    let categoryIds = new Array<number>(0);
    if (this.state.selectedCategoryIds.some(v => v === value)) {
      value = null;
      categoryIds = new Array<number>(0);
    } else {
      categoryIds.push(+value);
    }
    this.setState({
      selectionKeys: value,
      selectedCategoryIds: categoryIds.slice()
    });
  }

  //TODO: finish dragAndDrop with validations for parent and level of update.
  handleDragAndDropChange = (value) => {
    let draggedCategoryId = this.state.selectedCategoryIds[0];

    let deconstructedTree = this.deconstructTree(value, 0, 1);
    this.setState({
      isLoading: true
    });
    this.categoryService.updateCategoriesOrder(deconstructedTree).then(
      (data: any) => {
        this.snackbar.show({ severity: 'success', summary: Translate('Data Saved Successfully') });
        this.setState({
          isLoading: false,
          categories: deconstructedTree,
          treeCategories: value,
          expandToCategoryId: draggedCategoryId ? draggedCategoryId : 0
        });
        this.expandToCurrentCategory();
      })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  getSelectedCategoryNames = () => {
    let categoryNames = new Array<string>(0);
    this.state.categories.filter(a => this.state.selectedCategoryIds
      .some(b => b === a.id))
      .map(a => categoryNames.push(a.name));
    return categoryNames.join(', ');
  }

  getCategory = (id) => {
    this.categoryService.getCategory(id)
      .then(
        (data: CategoryModel) => {
          this.setCurrentCategory(data);
          this.setState({
            isLoading: false
          });
        })
      .catch(error => {
        this.snackbar.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  handleCancelButton = () => {
    this.showEditDialog(false);
  };

  setCurrentCategory(category: CategoryModel) {
    this.setState({ currentCategory: { ...category } });
  }

  showEditDialog = (show: boolean) => {
    this.setState({
      isVisibleAddEditDialog: show,
      validationMessage: ''
    });
    setTimeout(() => this.setState({
      isVisibleAddEditDialog: show
    }));
  };

  nodeTemplate(node) {
    if (node.data.levelNo === 1) {
      if (!node.data.isActive)
        return (
          <b style={{ opacity: 0.5 }}>{node.label}</b>
        )

      return (
        <b>{node.label}</b>
      )
    }

    if (!node.data.isActive) {
      return (
        <div style={{ opacity: 0.5 }}>{node.label}</div>
      )
    }

    return (
      <>{node.label}</>
    )
  }

  handleExpandClick = () => {
    let expandedKeys = {};

    this.state.categories.forEach(c => {
      expandedKeys[c.id.toString()] = true;
    });

    this.setState({
      expandedKeys: expandedKeys
    });
  }

  handleCollapseClick = () => {
    this.setState({
      expandedKeys: {}
    });
  }

  public render() {
    const { isLoading, selectedCategoryIds, treeCategories, selectionKeys, expandedKeys } = this.state;
    const categoryNamesForDelete = this.getSelectedCategoryNames();

    return (
      <div>
        <h1>{Translate("Categories")}</h1>

        {isLoading ? <Spinner /> : null}
        <Snackbar ref={(el) => this.snackbar = el} />

        {this.state.isVisibleAddEditDialog ? (
          <CategoryAddEditDialog
            closeAddEditCategoryModal={this.handleCloseAddEditCategoryModal}
            cancelClick={this.handleCancelButton}
            saveClick={this.handleSaveButton}
            currentCategory={this.state.currentCategory}
            isVisible={this.state.isVisibleAddEditDialog}
          />
        ) : null}

        <ConfirmDialog
          headerTitle={Translate("Confirm Dialog")}
          isVisible={this.state.isVisibleConfirmDialog}
          yesClick={() => { this.deleteCategoryTree(this.state.selectedCategoryIds[0]) }}
          noClick={() => { this.setState({ isVisibleConfirmDialog: false }) }}>
          {Translate("Are you sure that you want to delete")} "{categoryNamesForDelete}" {Translate("AndAllItsSubcategories")}?
        </ConfirmDialog>

        <div className="mb-2">
          <Button
            onClick={() => this.handleAddClick(null, 'root')}
            icon="pi pi-plus"
            className="p-button-success"
            style={{ marginRight: "5px" }}
            label={Translate("MainCategory")}
            tooltipOptions={{ position: 'top' }}
          />
          <Button
            onClick={() => this.handleAddClick(selectedCategoryIds[0], 'child')}
            icon="pi pi-plus"
            className="p-button-success"
            style={{ marginRight: "5px" }}
            label={Translate("SubCategory")}
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedCategoryIds && selectedCategoryIds.length === 1)}
          />
          <Button
            onClick={() => this.handleEditClick(selectedCategoryIds[0])}
            icon="pi pi-pencil"
            className="p-button-warning"
            style={{ marginRight: "5px" }}
            label={Translate("Edit")}
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedCategoryIds && selectedCategoryIds.length === 1)}
          />
          <Button
            onClick={() => this.handleDeleteClick()}
            icon="pi pi-trash"
            className="p-button-danger"
            style={{ marginRight: "5px" }}
            label={Translate("Delete")}
            tooltipOptions={{ position: 'top' }}
            disabled={!(selectedCategoryIds && selectedCategoryIds.length > 0)}
          />
        </div>

        <ContextMenu model={this.state.contextMenu} ref={el => this.cm = el} />

        <Paper style={{ padding: 10, backgroundColor: "#f5f5f5" }} >
          <div style={{ marginBottom: 10, display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              {Translate("Categories")} ({Translate("Type")})
              <div style={{ marginLeft: 5, cursor: "pointer" }}
                onClick={() => this.handleExpandClick()}
              >
                <FontAwesomeIcon
                  icon={faPlusSquare}
                  style={{ color: '#9e9e9e', fontSize: '1.5em' }}
                />
              </div>
              <div style={{ marginLeft: 5, cursor: "pointer" }}
                onClick={() => this.handleCollapseClick()}
              >
                <FontAwesomeIcon
                  icon={faMinusSquare}
                  style={{ color: '#9e9e9e', fontSize: '1.5em' }}
                />
              </div>
            </div>
          </div>
          <Tree
            value={treeCategories}
            style={{ width: "100%" }}
            selectionMode="single"
            selectionKeys={selectionKeys}
            onSelectionChange={e => this.handleSelectionChange(e.value)}
            onContextMenu={event => (selectedCategoryIds && selectedCategoryIds.length > 0 ? this.cm.show(event.originalEvent) : null)}
            expandedKeys={expandedKeys}
            onToggle={e => this.setState({ expandedKeys: e.value })}
            dragdropScope="demo"
            onDragDrop={event => this.handleDragAndDropChange(event.value)}
            nodeTemplate={this.nodeTemplate}
          />

          {/* <CategoriesView
            treeCategories={treeCategories}
            handleSelectionChange={this.handleSelectionChange}
            selectionKeys={selectionKeys}
            expandedKeys={expandedKeys}
            onContextMenu={event => (selectedCategoryIds && selectedCategoryIds.length > 0 ? this.cm.show(event.originalEvent) : null)}
            handleDragAndDropChange={this.handleDragAndDropChange}
            nodeTemplate={this.nodeTemplate}
          /> */}

        </Paper>
      </div>
    )
  }
}

export default CategoriesContainer